import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './OneBannerRight.scss';

const OneBannerRight = ({data, context}) => {
  const handleButtonClick = (link) => {
    if (link) {
      console.log('Navigating to:', link);
      context.navigateTo(link);
    }
  };

  return (
   <div className="one-banner-right">
    <div className="one-banner-right-content" style={{ backgroundColor: data.mainBackgroundColor }}>
      <div className="one-banner-right-background">
        {data.mainBackground && data.mainBackgroundType === 'video' && (
          <video className="one-banner-right-background-video" autoPlay loop muted playsInline>
            <source src={data.mainBackground} type="video/mp4" />
          </video>
        )}
        {data.mainBackground && (data.mainBackgroundType === 'image' || data.mainBackgroundType === 'gif') && (
          <Image className="one-banner-right-background-image" src={data.mainBackground} alt="Banner" />
        )}
      </div>
      <div className="one-banner-right-content-text-button">
        <div className="one-banner-right-main-text">
          <div className="one-banner-right-main-text-title" style={{ color: data.mainTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.mainText}} />
          {data.additionalText && (
            <div
              className="one-banner-right-additional-text"
              style={{ color: data.additionalTextColor || '#FFFFFF' }}
              dangerouslySetInnerHTML={{__html: data.additionalText}}
            />
          )}
          {data.secondaryText && (
            <div
              className="one-banner-right-secondary-text"
              style={{ color: data.secondaryTextColor || '#FFFFFF' }}
              dangerouslySetInnerHTML={{__html: data.secondaryText}}
            />
          )}
          <div className={`one-banner-right-button ${(data.mainButton?.text && data.mainButton?.link && data.secondaryButton?.text && data.secondaryButton?.link) ? 'one-banner-right-button--two-buttons' : ''}`}>
            {data.mainButton?.text && data.mainButton?.link && (
              <button
                className={`one-banner-right-button-text banner-button banner-button--${data.mainButton.style}`}
                onClick={() => handleButtonClick(data.mainButton.link)}>
                <span>{data.mainButton.text}</span>
              </button>
            )}
            {data.secondaryButton?.text && data.secondaryButton?.link && (
              <button
                className={`one-banner-right-button-text banner-button-secondary banner-button-secondary--${data.secondaryButton.style}`}
                onClick={() => handleButtonClick(data.secondaryButton.link)}>
                {data.secondaryButton.text}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
   </div>
  );
};

export default OneBannerRight;

